import React from "react";
import ReactDOM from "react-dom";
import "./App.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Helmet } from "react-helmet";

import logo from "./img/ivermedi.png";

window.APP = {
  //API: "http://192.168.1.5/ivermedi/api/",
  //baseName: "/",
  //MEDIA: "http://192.168.1.5/ivermedi/media/",
  API: "http://ivermedi.com/api/",
  baseName: "/",
  MEDIA: "http://ivermedi.com/media/",
};

ReactDOM.render(
  //<React.StrictMode>
  <BrowserRouter basename={window.APP.baseName}>
    <Helmet>
      <title>IVERMEDI</title>
      <meta name="description" content="IVERMEDI" />

      {/* <!-- Google / Search Engine Tags --> */}
      <meta itemprop="name" content="IVERMEDI" />
      <meta itemprop="description" content="IVERMEDI" />
      <meta itemprop="image" content={logo} />

      {/* <!-- Facebook Meta Tags --> */}
      <meta property="og:url" content={window.location.href} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="IVERMEDI" />
      <meta property="og:description" content="IVERMEDI" />
      <meta property="og:image" content={logo} />
    </Helmet>
    <App />
  </BrowserRouter>,
  //</React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
